module.exports = __webpack_public_path__ + "img/audit.8a1a9827.svg";